import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {PlaningDate} from '../../../../api/src/template/template.model';

@Component({
    selector: 'app-date-repeat-edit',
    templateUrl: './date-repeat-edit.component.html',
    styleUrls: ['./date-repeat-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DateRepeatEditComponent implements OnInit {
  @Input() planingDate: PlaningDate;
  @Input() idx: number;
  constructor() { }

  ngOnInit() {
  }

}
